import { useInfiniteQuery, useQuery } from 'react-query';
import axiosInstance from '../../Store/helper/axiosInstance';
import { GET_VAULT_LIST, SPECIALITY_VAULT_LIST } from '../QueryKeys/vault.key';

const cacheTime = 600000;

export const useVaultList = () => {
  return useQuery(GET_VAULT_LIST, () => axiosInstance.get('knwlg/myvault'), {
    refetchOnWindowFocus: false,
    cacheTime,
    select: (res) => res.data.data
  });
};

// SPECIALITY HOOKS

export const useSpecialityVaultList = () => {
  return useInfiniteQuery(
    [SPECIALITY_VAULT_LIST],
    ({ pageParam = 0 }) => axiosInstance.get(`knwlg/myvault?from=${pageParam}&to=20`),
    {
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length > 0) {
          // console.log(allPages.length);
          return allPages.length * 5;
        } else {
          return undefined;
        }
      },
      // staleTime: staleTime,
      cacheTime: cacheTime
    }
  );
};

